import { useEffect, useState } from "react";

const COUNTRY_DATA = {
  GB: { currency: "£", code: "GBP", flag: "🇬🇧", name: "United Kingdom" },
  US: { currency: "$", code: "USD", flag: "🇺🇸", name: "United States" },
  CA: { currency: "CA$", code: "CAD", flag: "🇨🇦", name: "Canada" },
  AU: { currency: "A$", code: "AUD", flag: "🇦🇺", name: "Australia" },
  DE: { currency: "€", code: "EUR", flag: "🇩🇪", name: "Germany" },
  FR: { currency: "€", code: "EUR", flag: "🇫🇷", name: "France" },
  NL: { currency: "€", code: "EUR", flag: "🇳🇱", name: "Netherlands" },
  SE: { currency: "kr", code: "SEK", flag: "🇸🇪", name: "Sweden" },
  NO: { currency: "kr", code: "NOK", flag: "🇳🇴", name: "Norway" },
  IN: { currency: "₹", code: "INR", flag: "🇮🇳", name: "India" },
  DEFAULT: { currency: "$", code: "USD", flag: "🌍", name: "International" },
};

const OFFERS = {
  GB: { amount: "£500", spins: "200", casino: "5Gringos", link: "https://fgrns.lynmonkel.com/?mid=389405_2246229" },
  US: { amount: "$1,000", spins: "200", casino: "LeoVegas", link: "https://leovegas.com" },
  CA: { amount: "CA$1,200", spins: "120", casino: "Royal Vegas", link: "https://royalvegas.com" },
  AU: { amount: "A$1,000", spins: "100", casino: "Spin Palace", link: "https://spinpalace.com" },
  DEFAULT: { amount: "$1,000", spins: "200", casino: "LeoVegas", link: "https://leovegas.com" },
};

export default function CountryDetector() {
  const [country, setCountry] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("geo_dismissed")) return;
    fetch("https://ipapi.co/json/")
      .then(r => r.json())
      .then(data => {
        const code = data.country_code || "DEFAULT";
        const info = COUNTRY_DATA[code] || COUNTRY_DATA.DEFAULT;
        const offer = OFFERS[code] || OFFERS.DEFAULT;
        setCountry({ ...info, ...offer, code });
        setTimeout(() => setVisible(true), 2000);
      })
      .catch(() => {
        setCountry({ ...COUNTRY_DATA.DEFAULT, ...OFFERS.DEFAULT, code: "DEFAULT" });
        setTimeout(() => setVisible(true), 2000);
      });
  }, []);

  if (!visible || dismissed || !country) return null;

  return (
    <div style={{
      position:"fixed", bottom:"80px", left:"20px", zIndex:999,
      background:"linear-gradient(135deg,#1a0533,#2d0a5e)",
      border:"1px solid rgba(168,85,247,0.4)",
      borderRadius:"16px", padding:"16px 20px", maxWidth:"300px",
      boxShadow:"0 0 30px rgba(139,44,226,0.3)",
      animation:"slideInLeft 0.4s ease",
    }}>
      <style>{"@keyframes slideInLeft{from{opacity:0;transform:translateX(-20px)}to{opacity:1;transform:translateX(0)}}"}</style>
      
      {/* Close button */}
      <button onClick={()=>{ setDismissed(true); sessionStorage.setItem("geo_dismissed","1"); }} 
        style={{position:"absolute",top:"8px",right:"10px",background:"transparent",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:"1rem",lineHeight:1}}>✕</button>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"10px"}}>
        <span style={{fontSize:"1.4rem"}}>{country.flag}</span>
        <div>
          <div style={{color:"rgba(255,255,255,0.5)",fontSize:"0.65rem",letterSpacing:"1px"}}>BEST OFFER FOR</div>
          <div style={{color:"white",fontWeight:"bold",fontSize:"0.85rem"}}>{country.name}</div>
        </div>
      </div>

      {/* Offer */}
      <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"10px",padding:"10px",marginBottom:"12px"}}>
        <div style={{color:"#ffd700",fontWeight:"bold",fontSize:"1.1rem"}}>{country.amount} + {country.spins} FS</div>
        <div style={{color:"rgba(255,255,255,0.5)",fontSize:"0.72rem",marginTop:"2px"}}>at {country.casino} • Exclusive offer</div>
      </div>

      {/* CTA */}
      <a href={country.link} target="_blank" rel="noopener noreferrer"
        style={{display:"block",textAlign:"center",background:"linear-gradient(135deg,#a855f7,#7c3aed)",color:"white",fontWeight:"bold",fontSize:"0.82rem",padding:"9px",borderRadius:"10px",textDecoration:"none",boxShadow:"0 0 15px rgba(168,85,247,0.4)"}}>
        🎁 Claim Your {country.currency} Bonus →
      </a>
    </div>
  );
}
